export const INSTITUTION_TRIAL_DEFAULT_DAYS = 15;

export const isInstitutionSubscriptionActive = (status: string | null): boolean => {
  return status === 'active' || status === 'trialing';
};
